import React from 'react';
import { Briefcase } from 'lucide-react';
import { Section, Card } from '../hospital/shared/primitives';
import { LinkRow, IntroRow } from '../shared/ListRows';

const ACCENT = '#334155';

const BCMResourcesFaculty = () => (
  <div className="space-y-6">
    <Card>
      <IntroRow icon={Briefcase} accent={ACCENT}>
        College-wide resources for faculty. Department faculty development is on the BCM Anesthesiology page.
      </IntroRow>
    </Card>

    <Section title="Development">
      <Card>
        <LinkRow title="Faculty Development" subtitle="College-wide programs and workshops" href="https://www.bcm.edu/research/centers/faculty-development" />
        <LinkRow title="Teaching Academy" subtitle="Teaching excellence and educational scholarship" href="https://www.bcm.edu/education/academic-faculty-affairs/teaching-academy" />
        <LinkRow title="Continuing Medical Education" subtitle="CME office and activities" href="https://www.bcm.edu/education/academic-faculty-affairs/cme" />
      </Card>
    </Section>

    <Section title="Research">
      <Card>
        <LinkRow title="BCM Libraries" subtitle="Databases, journals and research support" href="https://www.bcm.edu/libraries" />
        <LinkRow title="Office of Research" subtitle="Grant support and research administration" href="https://www.bcm.edu/research/office-of-research" />
      </Card>
    </Section>

    <Section title="Employment">
      <Card>
        <LinkRow title="Human Resources" subtitle="Benefits, policies and employee services" href="https://www.bcm.edu/education/academic-faculty-affairs/human-resources" />
      </Card>
    </Section>
  </div>
);

export default BCMResourcesFaculty;
